import styled from 'styled-components';
import { RowDiv } from 'styles';

export const ContentBox = styled.div`
  border-top: 2px solid ${({ theme }) => theme.colors.primary900};
  border-bottom: 2px solid ${({ theme }) => theme.colors.primary900};
  padding: 48px 16px;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 24px 0;
  }
`;

export const GridDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 24px;

  @media ${({ theme }) => theme.device.mobile} {
    display: flex;
    flex-direction: column;
  }
`;

export const ButtonBox = styled(RowDiv)`
  margin-top: 24px;
  align-items: center;
  justify-content: center;
  gap: 24px;
  @media ${({ theme }) => theme.device.mobile} {
    margin-top: 0;
    gap: 16px;
  }
`;
